import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TemplateEntityPeriodicityEnum } from '@zaoblako/shared/common/enums/template.entity.periodicity.enum';
import { TemplateEntityPeriodicityEnumI18n } from '@zaoblako/shared/common/i18n/template.entity.periodicity.enum.i18n';

@Pipe({
  standalone: true,
  name: 'periodicity'
})
export class PeriodicityPipe implements PipeTransform {
  public transform(periodicity: TemplateEntityPeriodicityEnum): string {
    const name = TemplateEntityPeriodicityEnumI18n[I18nLocalesEnum.RU_RU][periodicity];
    return name ? this.upperFirst(name) : '';
  }

  private upperFirst(value: string): string {
    if (value.length < 1) {
      return value;
    }

    const [first, ...rest] = value.split('');
    return [first.toUpperCase(), ...rest].join('');
  }
}
